import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { TDialogModal } from '@datatype/gridgio/type';

interface IState {
  // ############### dialog modal ###############
  isDialogModal: boolean;
  dialogModalData: TDialogModal | null;
}

const initialState: IState = {
  // ############### dialog modal ###############
  isDialogModal: false,
  dialogModalData: null,
};

const hideModalState = (state: IState) => {
  state.isDialogModal = false;
  state.dialogModalData = null;
};

const modalSlice = createSlice({
  name: 'gridgio-modal',
  initialState,
  reducers: {
    initialize: (state) => {
      for (const key in state) {
        state[key] = initialState[key];
      }
    },

    // ############### dialog modal ###############
    showDialogModal: (state, action: PayloadAction<TDialogModal>) => {
      state.isDialogModal = true;
      state.dialogModalData = action.payload;
    },

    hideModal: hideModalState,
    hideOverlay: hideModalState,
  },
});

export const actions = modalSlice.actions;
export default modalSlice.reducer;
